export enum HelpContactForm {
  Phone = 'Phone',
  Sms = 'Sms',
  Email = 'Email',
}

export const OtherTranslationId = 'General.Other';
export const HelpRequestEventName = 'help-successful-request';
export const HelpRequestedSubject = 'Help Requested!';
